//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React           from 'react';

import PropTypes       from '@components/PropTypes';
import ComponentHelper from '@helper/ComponentHelper';

import styles          from './styles.module.scss';

export class Label extends React.Component {
    static propTypes = {
        value: PropTypes.string,
    };

    static defaultProps = {
        value: null,
    };

    static renderAffectingProps = Object.keys(this.defaultProps);

    static renderAffectingStates = Object.keys(this.defaultProps);

    render() {
        return (
            <span className={styles.label}>
                {this.props.value}
            </span>
        );
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            nextProps,
            nextState,
        );
    }
}

export default Label;
